//import $ from 'jquery'
//import { gsap, CSSPlugin, ScrollToPlugin } from "gsap/all";
//import { Power4 } from "gsap";
//gsap.registerPlugin(ScrollToPlugin);
let mobileNav = {
  init: function () {

  },
};
export default mobileNav;
